export default "__VITE_ASSET__fc701333__"